import firebase from 'firebase/app';
import 'firebase/auth';
import Vue from 'vue'
import Router from 'vue-router'
import PageNotFound from '@/views/PageNotFound.vue'

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    } else {
        const position = {}
        if (to.hash) {
            position.selector = to.hash
            if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
                return position
            }
            return false
        }
        return new Promise(resolve => {
            this.app.$root.$once('triggerScroll', () => {
                resolve(position)
            })
        })
    }
}

const router = new Router({
    mode: "history",
    scrollBehavior,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue'),
            meta: {
                title: 'The Job Board for All Things Open Source'
            }
        },
        {
            path: '/faq',
            name: 'faq',
            component: () => import('./views/FAQ.vue'),
            meta: {
                title: 'faq'
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('./views/Dashboard.vue'),
            meta: {
                requiresAuth: true,
                title: 'My Job Posts'
            }
        },
        {
            path: '/dashboard/add',
            name: 'newjob',
            component: () => import('./views/NewJob.vue'),
            meta: {
                requiresAuth: true,
                title: 'Post a Job'
            }
        },
        {
            path: '/dashboard/edit/:id',
            name: 'edit',
            component: () => import('./views/EditJob.vue'),
            meta: {
                requiresAuth: true,
                title: 'Edit Job'
            }
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./views/Register.vue'),
            meta: {
                title: 'Register'
            }
        },
        {
            path: '/opensourcejob',
            name: 'opensourcejob',
            component: () => import('./views/OpenSourceJob.vue'),
            meta: {
                title: 'What is and Open Source Job?'
            }
        },
        {
            path: '/opensourcescore',
            name: 'opensourcescore',
            component: () => import('./views/OpenSourceScore.vue'),
            meta: {
                title: 'What is an Open Source Score?'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue'),
            meta: {
                title: 'Login'
            }
        },
        {
            path: '/forgot',
            name: 'forgot',
            component: () => import('./views/Forgot.vue'),
            meta: {
                title: 'Forgot Password'
            }
        },
        {
            path: '/email',
            name: 'email',
            component: () => import('./views/Email.vue'),
            meta: {
                title: 'Email'
            }
        },
        {
            path: '/admin',
            name: 'admin',
            component: () => import('./views/Admin.vue'),
            meta: {
                requiresAuth: true,
              title: 'Admin'
            }
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('./views/About.vue'),
            meta: {
                title: 'About Open Source Jobs'
            }
        },
        {
            path: '/termsofservice',
            name: 'tos',
            component: () => import('./views/Tos.vue'),
            meta: {
                title: 'Terms of Service'
            }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () => import('./views/Privacy.vue'),
            meta: {
                title: 'Privacy Policy'
            }
        },
        {
            path: "*",
            component: PageNotFound
        }
    ]
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) {
    next('login')
  }
  else next()
})

export default router
